import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { BASKET_DEAL_PRODUCT_AVAILABLE_DATES } from '../../brands/default/content/components/checkout';
import ThemeContext from '../../providers/ThemeProvider';

export default function BasketDealProductAvailableDates({ numAvailableDates }) {
  const theme = useContext(ThemeContext);

  if (numAvailableDates < 20) return null;

  return (
    <>
      <p className="availability-message">
        {BASKET_DEAL_PRODUCT_AVAILABLE_DATES.getAvailableDatesText(
          numAvailableDates,
        )}
      </p>
      <style jsx>{`
        .availability-message {
          color: ${theme.colors.socialcuecolor.assure};
          margin: 4px 0 4px 0;
          font-weight: bold;
        }
      `}</style>
    </>
  );
}

BasketDealProductAvailableDates.propTypes = {
  numAvailableDates: PropTypes.number,
};
